import { HIDDEN_SPEC_FIELDS, type HiddenSpecField } from '../../../types/product'

// `bs_hidden_spec_fields` from the product detail. The key is absent until a
// product first stores it; unknown values and duplicates are dropped.
export function parseHiddenSpecFields(raw: unknown): HiddenSpecField[] {
  if (!Array.isArray(raw)) return []
  const out: HiddenSpecField[] = []
  for (const value of raw) {
    if ((HIDDEN_SPEC_FIELDS as unknown[]).includes(value) && !out.includes(value as HiddenSpecField)) {
      out.push(value as HiddenSpecField)
    }
  }
  return out
}
